module.exports = __webpack_public_path__ + "img/loader.98ccf99a.svg";